import api from '../api';
const baseUrl = process.env.REACT_APP_AUTH_API_URL;

const getPublishablesByUser = async (userId, keycloakToken) => {
    try {
        const response = await api.get(`${baseUrl}/publishables/user/${userId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching publishables", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar entregáveis");
    }
}

const getPublishablesByProject = async (projectId, keycloakToken) => {
    try {
        const response = await api.get(`${baseUrl}/publishables/project/${projectId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching publishables", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar entregáveis");
    }
}

const downloadPublishablesZipByUser = async (userId, keycloakToken, selectedProjectId) => {
    try {
        const response = await api.get(`${baseUrl}/publishables/user/${userId}/zip/${selectedProjectId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
            responseType: 'blob',
        });

        return response.data;
    } catch (error) {
        console.error("Error downloading publishables zip", error);
        throw new Error(error?.response?.data?.message || "Erro ao baixar entregáveis");
    }
}

const deletePublishableById = async (publishableId, keycloakToken) => {
    try {
        const response = await api.delete(`${baseUrl}/publishables/${publishableId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting publishable", error);
        throw new Error(error?.response?.data?.message || "Erro ao remover publicação");
    }
}

export default { getPublishablesByUser, getPublishablesByProject, downloadPublishablesZipByUser, deletePublishableById };